export const setStartPoint = (element: HTMLElement | null) => {
  if (window.speechstream?.domControlTools && element) {
    window.speechstream.domControlTools.setStartPoint(element);
  }
};
